export default __webpack_public_path__ + "static/media/07_dentsu.0ccc4b38.png";